const comments = [
  {
    name: '追番小王子',
    text: '51动漫官网真的太方便了！日漫更新速度超快，画质清晰，下拉式追番体验比翻页舒服太多了，已经推荐给身边所有漫友了！',
    tag: '日漫爱好者',
    date: '3天前',
  },
  {
    name: '国漫铁粉',
    text: '一直在找稳定的国漫在线观看平台，51动漫官网没让我失望。全职高手、斗罗大陆这些热门国漫全集都有，下载速度也很快，好评！',
    tag: '国漫忠实观众',
    date: '5天前',
  },
  {
    name: '韩漫入坑人',
    text: '韩漫资源很全，我追的几部热门韩漫这里都能找到，免费下载太良心了。下拉式阅读看韩漫长条简直绝配，体验感拉满！',
    tag: '韩漫新粉',
    date: '1周前',
  },
  {
    name: '老二次元了',
    text: '用51动漫官网三年了，从追日漫到看国漫再到入坑韩漫，资源越来越丰富。动漫全集下载功能一直很稳定，出差路上全靠它续命。',
    tag: '资深动漫迷',
    date: '2周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100/70">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          漫友热评
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {comments.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-accent-600 font-heading text-sm">
                    {item.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <span className="text-xs text-accent-600 bg-accent-50 px-2 py-0.5 rounded-full">
                    {item.tag}
                  </span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                &ldquo;{item.text}&rdquo;
              </p>
              <div className="mt-3 text-xs text-foreground-400">{item.date}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}